import { Http } from 'api/apiWrapper';

type ServiceUrls = {
  apiUrl: string;
  dataImporterUrl: string;
  publicApiUrl: string;
  usersApiUrl: string;
};

export type BaseServiceConstructor = {
  serviceUrls: ServiceUrls;
  token?: string;
  tenantName: string;
};

export abstract class BaseService {
  protected httpClient: Http;
  protected publicHttpClient: Http;
  protected tenantlessPublicHttpClient: Http;
  protected usersHttpClient: Http;
  protected dataImporterHttpClient: Http;
  protected tenantName: string;

  protected constructor({
    serviceUrls: { apiUrl, dataImporterUrl, publicApiUrl, usersApiUrl },
    token,
    tenantName,
  }: BaseServiceConstructor) {
    this.httpClient = new Http(apiUrl, token, tenantName);
    this.publicHttpClient = new Http(`${publicApiUrl}/${tenantName}`, token, tenantName);
    this.tenantlessPublicHttpClient = new Http(`${publicApiUrl}`, token, tenantName);
    this.usersHttpClient = new Http(usersApiUrl, token, tenantName);
    this.dataImporterHttpClient = new Http(dataImporterUrl, token, tenantName);
    this.tenantName = tenantName;
  }
}
